import TankNode from './TankNode';

import PumpNode from './PumpNode';
import MotorNode from './MotorNode';
import ValveNode from './ValveNode';
import LEDIndicatorNode from './LEDIndicatorNode';
import DigitalDisplayNode from './DigitalDisplayNode';
import TextLabelNode from './TextLabelNode';
import RectShapeNode from './RectShapeNode';
import CircleShapeNode from './CircleShapeNode';
import ImageEmbedNode from './ImageEmbedNode';
import LineArrowNode from './LineArrowNode';
import AlarmBannerNode from './AlarmBannerNode';
import TrendChartNode from './TrendChartNode';
import TemperatureGaugeNode from './TemperatureGaugeNode';
import PressureGaugeNode from './PressureGaugeNode';
import FlowMeterNode from './FlowMeterNode';
import LevelIndicatorNode from './LevelIndicatorNode';
import HumiditySensorNode from './HumiditySensorNode';
import CycloneNode from './CycloneNode';
import RibbonBlenderNode from './RibbonBlenderNode';
import CoolerBlenderNode from './CoolerBlenderNode';
import HopperScrewNode from './HopperScrewNode';
import GranulatorNode from './GranulatorNode';
import ScrewConveyorNode from './ScrewConveyorNode';
import BucketElevatorNode from './BucketElevatorNode';
import PackagerSingleNode from './PackagerSingleNode';
import PackagerMultiNode from './PackagerMultiNode';
import PackagerDoypakNode from './PackagerDoypakNode';
import BoxFormerNode from './BoxFormerNode';
import StripFolderNode from './StripFolderNode';
import BoxSealerNode from './BoxSealerNode';
import CustomMachineNode from './CustomMachineNode';
import Valve3WayNode from './Valve3WayNode';
import ChillerNode from './ChillerNode';
import CompressorNode from './CompressorNode';
import BoilerNode from './BoilerNode';
import WaterHeaterNode from './WaterHeaterNode';
import VBlenderNode from './VBlenderNode';
import SieveNode from './SieveNode';
import BeltConveyorNode from './BeltConveyorNode';
import CipSkidNode from './CipSkidNode';

const scadaNodeTypes = {
    // Proceso general
    tank: TankNode,
    pump: PumpNode,
    motor: MotorNode,
    valve_gate: ValveNode,
    valve_ball: ValveNode,
    valve_butterfly: ValveNode,
    valve_check: ValveNode,
    valve_3way: Valve3WayNode,
    regulator: ValveNode,
    // Sensores
    sensor_temp: TemperatureGaugeNode,
    sensor_pressure: PressureGaugeNode,
    sensor_flow: FlowMeterNode,
    sensor_level: LevelIndicatorNode,
    sensor_humidity: HumiditySensorNode,
    // Display
    display_digital: DigitalDisplayNode,
    display_trend: TrendChartNode,
    led_indicator: LEDIndicatorNode,
    alarm_banner: AlarmBannerNode,
    // Formas
    shape_rect: RectShapeNode,
    shape_circle: CircleShapeNode,
    shape_line: LineArrowNode,
    text_label: TextLabelNode,
    image_embed: ImageEmbedNode,
    // Industria alimentaria / química
    cyclone: CycloneNode,
    ribbon_blender: RibbonBlenderNode,
    cooler_blender: CoolerBlenderNode,
    hopper_screw: HopperScrewNode,
    granulator: GranulatorNode,
    screw_conveyor: ScrewConveyorNode,
    bucket_elevator: BucketElevatorNode,
    packager_single: PackagerSingleNode,
    packager_multi: PackagerMultiNode,
    packager_doypack: PackagerDoypakNode,
    // Fin de línea (end-of-line packaging)
    box_former: BoxFormerNode,
    strip_folder: StripFolderNode,
    box_sealer: BoxSealerNode,
    // Eléctrico (fallback a rect)
    breaker: RectShapeNode,
    switch_elec: RectShapeNode,
    transformer: RectShapeNode,
    generator: MotorNode,
    // Equipamiento auxiliar
    chiller: ChillerNode,
    compressor: CompressorNode,
    boiler: BoilerNode,
    water_heater: WaterHeaterNode,
    // Proceso general adicional
    v_blender: VBlenderNode,
    sieve: SieveNode,
    belt_conveyor: BeltConveyorNode,
    // CIP (Clean-in-Place)
    cip_skid: CipSkidNode,
    // Máquina genérica
    custom_machine: CustomMachineNode,
};

export default scadaNodeTypes;
